import React from "react";
import SimpleImageSlider from "react-simple-image-slider";
import "./imgslider.css";
import { useState } from "react";


function ImageSliderComponent() {
  
   
  const images = [
    { url: "./Images/BannerSitioWeb2.png" },
    { url: "./Images/BannersSitioWeb.png" },
  ];
  return (
    <div className="wrap-slider-container">
      <div className="wrap-slider">
        <SimpleImageSlider
          width={"98%"}
          height={"35vw"}
          images={images}
          showBullets={true}
          showNavs={true}
          autoPlay={true}
          slideDuration={0.5}
          autoPlayDelay={6}

          
        />
      </div>
    </div>
   
  );
}

export default ImageSliderComponent;
